import { css, cva } from "../../styled-system/css";

/**
 * @deprecated 代わりに`typographyStyles`の`ellipsis`を使用する。
 */
export const ellipsis = css.raw({
  minWidth: 0,
  overflow: "clip",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

/**
 * @deprecated 代わりに`typographyStyles`の`monospace`を使用する。
 */
export const monospace = css.raw({
  fontFamily: '"Fira Code", monospace',
  fontKerning: "none",
});

export const TypographyStyle = cva({
  variants: {
    color: {
      default: { color: "#18181B" },
      error: { color: "destructive" },
      muted: { color: "#71717A" },
      primary: { color: "primary" },
      "primary/30": { color: "primary/30" },
      "primary/60": { color: "primary/60" },
      secondary: { color: "secondary" },
    },
    display: {
      block: { display: "block" },
    },
    ellipsis: {
      true: { minWidth: 0, overflowX: "clip", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    },
    flexGrow: {
      1: { flexGrow: 1 },
    },
    flexShrink: {
      0: { flexShrink: 0 },
    },
    fontSize: {
      "10px": { fontSize: "10px" },
      "12px": { fontSize: "12px" },
      "14px": { fontSize: "14px" },
      "16px": { fontSize: "16px" },
      "18px": { fontSize: "18px" },
      "20px": { fontSize: "20px" },
      "24px": { fontSize: "24px" },
      "36px": { fontSize: "36px" },
    },
    fontWeight: {
      400: { fontWeight: 400 },
      500: { fontWeight: 500 },
      600: { fontWeight: 600 },
      700: { fontWeight: 700 },
    },
    lineHeight: {
      1: { lineHeight: 1 },
      1.42857142857: { lineHeight: 1.42857142857 },
      1.55555555556: { lineHeight: 1.55555555556 },
      "10 / 7": { lineHeight: /** 1.428571… */ 10 / 7 },
      "14 / 9": { lineHeight: /** 1.5… */ 14 / 9 },
    },
    link: {
      true: {
        cursor: "pointer",
        _hover: { textDecoration: "underline" },
        _disabled: { cursor: "not-allowed", opacity: 0.4 },
      },
    },
    marginTop: {
      "2px": { marginTop: "2px" },
      "4px": { marginTop: "4px" },
      "6px": { marginTop: "6px" },
      "8px": { marginTop: "8px" },
      "12px": { marginTop: "12px" },
      "16px": { marginTop: "16px" },
      "20px": { marginTop: "20px" },
      "24px": { marginTop: "24px" },
    },
    monospace: {
      true: { fontFamily: '"Fira Code", monospace', fontKerning: "none" },
    },
    size: {
      small: { fontSize: "14px", lineHeight: 1.42857142857 },
      large: { fontSize: "18px", lineHeight: 1.55555555556 },
    },
    textAlign: {
      left: { textAlign: "left" },
      center: { textAlign: "center" },
      right: { textAlign: "right" },
    },
    textDecoration: {
      underline: { textDecoration: "underline" },
    },
    verticalAlign: {
      middle: { verticalAlign: "middle" },
    },
    whiteSpace: {
      "pre-wrap": { whiteSpace: "pre-wrap" },
    },
    width: {
      stretch: { width: "stretch" },
    },
    wordBreak: {
      "break-all": { wordBreak: "break-all" },
      "keep-all": { wordBreak: "keep-all" },
    },
  },
});

/**
 * @deprecated 代わりに`TypographyStyle`を使用する。
 */
export const typographyStyles = TypographyStyle;

/**
 * @deprecated 代わりに`TypographyStyle`を使用する。
 */
export const TYPOGRAPHY_STYLES = TypographyStyle;
